"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var OnPageNav = /** @class */ (function (_super) {
    __extends(OnPageNav, _super);
    function OnPageNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreScroll = false;
        // Triggered when an item is clicked in the OnPageNav
        _this.itemLabelClicked = function (navItem, index, event) {
            if (_this.props.itemClicked) {
                // Trigger the itemClicked prop callback
                _this.props.itemClicked(navItem, index);
                // Attempt to scroll to the nav item id or ref
                _this.scrollToNavItem(navItem);
            }
        };
        // Triggered when an item is scrolled into view, comes from the window event listener callback
        _this.itemScrolledIntoView = function (navItems, index) {
            if (_this.props.itemScrolledIntoView) {
                _this.props.itemScrolledIntoView(navItems, index);
            }
        };
        // Generate the link elements for the OnPageNav
        _this.getLinks = function () {
            var links = [];
            var _a = _this.props, navItems = _a.navItems, activeItemIndex = _a.activeItemIndex;
            navItems.forEach(function (navItem, index) {
                var linkClasses = classNames('nav-bar__link', {
                    'nav-bar__link--active': activeItemIndex === index
                });
                links.push(React.createElement("a", { className: linkClasses, key: navItem.title, onClick: function (e) {
                        _this.itemLabelClicked(navItem, index, e);
                    } }, navItem.title));
            });
            return links;
        };
        // Helper method to scroll to a specific navItem
        _this.scrollToNavItem = function (navItem) {
            var _a = _this.props, scrollOffset = _a.scrollOffset, scrollDuration = _a.scrollDuration;
            // Get the scroll position of the navItem
            var position = _this.handleScroll()[navItem.title];
            if (position) {
                position -= scrollOffset;
                var currentPosition_1 = window.scrollY;
                var offset_1 = Math.round((position - currentPosition_1) / scrollDuration);
                var interval_1 = setInterval(function () {
                    if (Math.abs(currentPosition_1 - position) > Math.abs(offset_1)) {
                        _this.ignoreScroll = true;
                        currentPosition_1 += offset_1;
                        window.scrollTo(0, currentPosition_1);
                    }
                    else {
                        _this.ignoreScroll = false;
                        window.scrollTo(0, position);
                        clearInterval(interval_1);
                    }
                }, scrollDuration);
            }
        };
        // Returns the scroll positions by navItem.title. Used as an event listener for scroll events.
        _this.handleScroll = function () {
            // ignoreScroll is true when in the middle of a scroll
            // return early to avoid triggering 'itemScrolledIntoView' when scrolling past an element
            if (_this.ignoreScroll) {
                return {};
            }
            var _a = _this.props, scrollOffset = _a.scrollOffset, scrollDuration = _a.scrollDuration, navItems = _a.navItems;
            // Calculate scroll positions for all refs in navItems
            var newScrollPositions = {};
            navItems.forEach(function (navItem, index) {
                // Find the node using the provided id or ref element
                var node = null;
                if (navItem.id) {
                    var el = document.getElementById(navItem.id);
                    node = ReactDOM.findDOMNode(el);
                }
                else if (navItem.ref) {
                    node = ReactDOM.findDOMNode(navItem.ref);
                }
                // If the node is not found, the position of the node won't be added to scrollPositions.
                if (node) {
                    var _a = node.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
                    newScrollPositions[navItem.title] = top_1 + window.scrollY;
                    if (top_1 <= scrollOffset && bottom > scrollOffset) {
                        // If there's a new node within range, pass back the potential new activeItemIndex
                        _this.itemScrolledIntoView(navItem, index);
                    }
                }
            });
            return newScrollPositions;
        };
        return _this;
    }
    OnPageNav.prototype.componentDidMount = function () {
        monitoring_1.default('onPageNav');
        // Add a scroll event listener to update the OnPageNav when the page is scrolled by the user
        if (this.props.handleScrolling) {
            window.addEventListener('scroll', this.handleScroll);
        }
    };
    OnPageNav.prototype.componentWillUnmount = function () {
        // Remove the scroll event listener when the component unmounts
        if (this.props.handleScrolling) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    };
    OnPageNav.prototype.render = function () {
        var _a = this.props, activeItemIndex = _a.activeItemIndex, title = _a.title, className = _a.className, style = _a.style;
        var classes = classNames('nav-bar', className);
        return (React.createElement("div", { className: classes, style: style },
            title ? React.createElement("h3", { className: "nav-bar__title" }, title) : null,
            React.createElement("div", { className: "nav-bar__links current-link" + activeItemIndex }, this.getLinks())));
    };
    OnPageNav.defaultProps = {
        activeItemIndex: 0,
        scrollOffset: 100,
        scrollDuration: 10,
        handleScrolling: true
    };
    return OnPageNav;
}(React.Component));
exports.default = OnPageNav;
//# sourceMappingURL=OnPageNav.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/OnPageNav/OnPageNav.js
// module id = 261
// module chunks = 0